var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14.306,
    viewBox: "0 0 12 14.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M15.467,11.294l-.048.058a7.725,7.725,0,0,1-5.952,2.954,7.725,7.725,0,0,1-5.952-2.954l-.048-.058.011-.074A6.134,6.134,0,0,1,6.42,6.7l.113-.065.09.094a3.921,3.921,0,0,0,5.688,0l.09-.094.113.065a6.135,6.135,0,0,1,2.942,4.524Zm-6-4.15A3.572,3.572,0,1,0,5.895,3.572,3.576,3.576,0,0,0,9.467,7.144Z",
    transform: "translate(-3.467)",
    fill: "#bd1f60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.23324d9220634febb46f398f748f97c9.svg";
export { ForwardRef as ReactComponent };